import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useMemo } from 'react';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

interface UseViewTemplateLayoutReturnType {
  layout?: API.ViewTemplateLayoutFragment;
  loading: boolean;
  error?: Error;
}

export function useViewTemplateLayout(
  workflowTemplateId?: string | null,
  viewTemplateId?: string | null,
): UseViewTemplateLayoutReturnType {
  const { data, loading, error } = useQuery<
    API.GetViewTemplateLayoutQuery,
    API.GetViewTemplateLayoutQueryVariables
  >(Queries.viewTemplate.getViewTemplateLayout, {
    variables: {
      input: {
        workflowTemplateId: workflowTemplateId ?? '',
        viewTemplateId: viewTemplateId ?? '',
      },
    },
    skip: isNil(workflowTemplateId) || isNil(viewTemplateId),
  });

  return useMemo(() => {
    return {
      layout: data?.getViewTemplateLayout ?? undefined,
      loading,
      error,
    };
  }, [data, loading, error]);
}
